import { Submenu } from '../menus/Submenu';
import React, { useCallback, useRef } from 'react';
import { Divider } from '../Surface/Divider';
import {
  isMenuEntry,
  isMenuGroup,
  MenuEntry,
  MenuGroup
} from './CommandBar/CommandBarUI/types';
import { ButtonTypes } from '../themes/custom-theme';
import { PopoverMenuClassType } from '../menus/PopOverMenu/PopoverMenu';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import { ContextMenuListItem } from '@cube3/cubicle/src/core/molecules/ContextMenu/ContextMenuListItem';
import { iconFiles } from '@cube3/cubicle/src/core/atoms/Icon/files';

interface Props {
  entry: any;
  classes?: PopoverMenuClassType;
  closeFn?: Function;
  variant?: ButtonTypes;
  'data-type'?: 'librarydeselectoverride';
}

export const RenderSubmenuButton = (props: Props) => {
  const { entry, closeFn, classes } = props;

  if (!entry.visible) return null;
  if (entry.isDivider)
    return <Divider key={entry.title} direction="horizontal" />;

  const handleClick = useCallback(
    (ev) => {
      closeFn();
      return entry.onClick(ev, entry.extraClickArgs);
    },
    [entry.onClick, entry.extraClickArgs, closeFn]
  );

  return (
    <div className={classes?.root}>
      <ContextMenuListItem
        value={entry.title}
        dataType={props['data-type']}
        key={entry.title}
        disabled={entry.disabled}
        disabledReason={entry.disabledReason}
        leftIcon={entry.icon ? entry.icon : iconFiles}
        onClick={handleClick}
        modifiers={entry.shortCut?.tip}
        modifierSize={SizeVariants.sm}
        showChevron={entry.extraButtonProps ? true : false}
      />
    </div>
  );
};

export const RenderTooltip = ({ entry, className = '' }) => {
  return (
    <ContextMenuListItem
      value={entry.title}
      disabled={true}
      key={entry.title}
      disabledReason={entry.disabledReason}
      onClick={() => console.warn('Disabled')}
      leftIcon={entry.icon ? entry.icon : undefined}
      showChevron={false}
      color="02"
    />
  );
};

export const RenderSubmenuContent = (props: Props) => {
  const { entry, closeFn, variant, classes } = props;
  const lastEntry = useRef(null);
  lastEntry.current = null;

  if (!entry.visible) return null;
  if (entry.disabled)
    return <RenderTooltip entry={entry} className={classes?.menuButton} />;

  return (
    <Submenu
      key={entry.title}
      text={entry.title}
      variant={variant}
      classProps={classes}
      leftSvgPath={entry.icon ? entry.icon : undefined}
      childrenRenderProps={(close, isOpen) => {
        return (
          <React.Fragment>
            {entry.children &&
              (entry.children as Array<MenuEntry | MenuGroup>).map((child) => {
                if (isMenuEntry(child)) {

                  if (child.children) {

                    return <RenderSubmenuContent
                      key={child.title}
                      entry={child}
                      classes={{ menuButton: classes.menuButton, root: classes.root }}
                      data-type="librarydeselectoverride"
                    />
                  }


                  if (child.component) {
                    return (
                      <div
                        key={child.title}
                        data-type="librarydeselectoverride"
                        style={{ minWidth: 225 }}
                      >
                        {child.component(closeFn ? closeFn : close, isOpen)}
                      </div>
                    ); // closeFn: commandbar buttons use different handleClose function
                  }
                  return (
                    <RenderSubmenuButton
                      key={child.title}
                      entry={child}
                      closeFn={closeFn ? closeFn : close}
                      classes={classes}
                      data-type="librarydeselectoverride"
                    />
                  );
                }

                if (isMenuGroup(child))
                  return (child.entries).map((cEntry) => (
                    <RenderSubmenuButton
                      key={cEntry.title}
                      entry={cEntry}
                      closeFn={closeFn ? closeFn : close}
                      classes={classes}
                      data-type="librarydeselectoverride"
                    />
                  ));

                return null;
              })}
          </React.Fragment>
        );
      }}
    />
  );
};
